import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import { OWNER, OR_ADMIN, OR_SUPERUSER } from 'constants/roles';
import RBACWrapper from 'components/RBACWrapper/RBACWrapperContainer';
import ApiTokenCardContainer from './ApiTokenCard/ApiTokenCardContainer';
import ProfileCardContainer from './ProfileCard/ProfileCardContainer';
import OrganizationCardContainer from './OrganizationCard/OrganizationCardContainer';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
};

export function UnstyledPersonalInfoTab({ classes }) {
  return (
    <div className={classes.root}>
      <ProfileCardContainer className={classes.profileCard} />
      <RBACWrapper roles={[OWNER, OR_ADMIN, OR_SUPERUSER]}>
        <ApiTokenCardContainer className={classes.apiCard} />
      </RBACWrapper>
      <OrganizationCardContainer className={classes.orgCard} />
    </div>
  );
}

UnstyledPersonalInfoTab.propTypes = propTypes;

const styles = (theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    gridAutoFlow: 'dense',
    gridTemplateAreas: `
    'profile org'
    'api org'
    '. org'
  `,
  },
  profileCard: {
    gridArea: 'profile',
  },
  orgCard: {
    gridArea: 'org',
  },
  apiCard: {
    gridArea: 'api',
  },
  [theme.breakpoints.down('md')]: {
    root: {
      flexDirection: 'column',
      gridTemplateColumns: '1fr',
      gridGap: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      gridTemplateAreas: `
      'profile'
      'org'
      'api'
    `,
    },
  },
});

export default withStyles(styles)(UnstyledPersonalInfoTab);
